export const optionsShortNames: Intl.DateTimeFormatOptions = {
  year: '2-digit',
  month: 'short',
  weekday: 'short',
  day: 'numeric'
};

export const optionsLongMonth: Intl.DateTimeFormatOptions = {
  year: 'numeric',
  month: 'long',
  day: 'numeric'
};
